/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

//search feature
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Col from "react-bootstrap/esm/Col";
import Form from "react-bootstrap/esm/Form";
import InputGroup from "react-bootstrap/esm/InputGroup";
import { ROUTES } from "../../../utils/routes";
import Axios from "axios";
import { getAll, getByInvestigator } from "../../../utils/requests/dynamicReq";
import { paths } from "../../../utils/paths";
import { useSelector } from "react-redux";
import { IStore } from "../../../interfaces/IStore";
import { IUser } from "../../../interfaces/IUser";
import { normalizer } from "../../../utils/auxiliar/investigators";
import { Table } from "react-bootstrap";
import * as XLSX from "xlsx";

export const Projects: FC = () => {
  let { staffId, isAdmin, userRoleId } = useSelector(
    ({ user }: IStore) => user as IUser
  );
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { PROJECTS } = paths;
  const [projects, setProjects] = useState<IProjectShort[]>([]);
  const [displayProjects, setDisplayProjects] = useState<IProjectShort[]>([]);
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: string;
  } | null>(null);

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    loadData();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);
  interface IProjectShort {
    [key: string]: any;
    id: string;
    tituloEs: string;
    tituloEn: string;
    tituloVa: string;
    acronimo: string;
    observaciones: string;
    resumenEs: string;
    resumenEn: string;
    resumenVa: string;
    tipo: string;
    produccionPersonal: boolean;
    selected: boolean;
    palabrasClaveEs: string;
    palabrasClaveEn: string;
    palabrasClaveVa: string;
    referenciaOficial: string;
    estado: string;
    referenciaInterna: string;
    fechaInicio: string;
    fechaProrroga: string;
    gestionadoPor: string | null;
    staffProjects?: {
      projectRole: string;
      staff: { nombre: string; apellidos: string };
    }[];
  }

const loadData = async () => {
  try {
    const response = await getAll(PROJECTS, source);

    if (isMountedRef.current) {
      let filteredProjects = response;

      // Si el usuario NO es admin, aplicar el filtro
      if (!isAdmin) {
        filteredProjects = response.filter(
          (project: any) =>
            project.staffProjects.some((staff: any) => staff?.staff?.id === staffId) 
        );
      }

      setProjects(filteredProjects);
      setDisplayProjects(filteredProjects);
    }
    setIsLoading(false);
  } catch (error) {
    console.log("HTTP call cancelled");
  }
};

  const searchBar = (value: string) => {
    const lowerCaseValue = value.toLowerCase(); // Solo convierte el valor a minúsculas

    setDisplayProjects(
      projects.filter(
        ({ tituloEs }) => tituloEs.toLowerCase().includes(lowerCaseValue) // Filtra solo por tituloEs
      )
    );

    if (!value) {
      setDisplayProjects(projects);
    }
  };

  const sortByColumn = (key: keyof IProjectShort) => {
    let direction = "desc";

    if (sortConfig?.key === key && sortConfig.direction === "desc") {
      direction = "asc";
    }

    setSortConfig({ key: key as string, direction });

    const sortedData = [...displayProjects].sort((a, b) => {
      if (key === "staffProjects") {
        // Extraer el apellido del primer IP en cada proyecto o asignar una cadena vacía si no existe
        const lastNameA =
          a.staffProjects?.find(({ projectRole }) => projectRole === "ip")
            ?.staff?.apellidos || "";
        const lastNameB =
          b.staffProjects?.find(({ projectRole }) => projectRole === "ip")
            ?.staff?.apellidos || "";

        // Proyectos sin IPs deben ir al final
        if (!lastNameA && lastNameB) return 1;
        if (!lastNameB && lastNameA) return -1;
        if (!lastNameA && !lastNameB) return 0;

        return (
          lastNameA.localeCompare(lastNameB) * (direction === "asc" ? 1 : -1)
        );
      }

      return a[key] < b[key]
        ? direction === "asc"
          ? -1
          : 1
        : a[key] > b[key]
        ? direction === "asc"
          ? 1
          : -1
        : 0;
    });

    setDisplayProjects(sortedData);
  };

  const columnHeaders: Record<string, string> = {
    tituloEs: "TÍTULO", // Cambio aquí, pero mantiene la clave "acronimo"
    estado: "ESTADO",
    referenciaInterna: "REFERENCIA",
    fechaInicio: "FECHA INICIO",
    fechaProrroga: "FECHA PRORROGA",
    staffProjects: "IPS",
    gestionadoPor: "GESTIONADO POR",
  };

  const handleExportToExcel = () => {
    if (!projects) return;

    const dataToExport = projects.map((project) => ({
      ID: project.id,
      "Título (ES)": project.tituloEs,
      "Título (EN)": project.tituloEn,
      "Título (VA)": project.tituloVa,
      Acrónimo: project.acronimo,
      Observaciones: project.observaciones,
      "Resumen (ES)": project.resumenEs,
      "Resumen (EN)": project.resumenEn,
      "Resumen (VA)": project.resumenVa,
      Tipo: project.tipo,
      "Producción Personal": project.produccionPersonal ? "Sí" : "No",
      "Referencia Oficial": project.referenciaOficial,
      Estado: project.estado,
      "Referencia Interna": project.referenciaInterna,
      "Fecha Inicio": project.fechaInicio,
      "Fecha Prórroga": project.fechaProrroga,
      "Gestionado Por": project.gestionadoPor || "",
      Staff:
        project.staffProjects
          ?.map(
            (s) =>
              `${s.projectRole}: ${
                s.staff
                  ? `${s.staff.nombre} ${s.staff.apellidos}`
                  : "Sin asignar"
              }`
          )
          .join(" | ") || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");

    XLSX.writeFile(workbook, "projects.xlsx");
  };

  return (
    <div className="container-fluid p-4">
      {(isAdmin || userRoleId === 2 || userRoleId === 3) && (
        <>
          {" "}
          <div className="row">
            <div className="col d-flex justify-content-between">
              <div>
                <h3>Proyectos</h3>
              </div>
              <div>
                <button
                  className="baseBtn"
                  onClick={() => history.push(ROUTES.Projects.create)}
                >
                  + Añadir
                </button>
                <button className="baseBtn ml-2" onClick={handleExportToExcel}>
                  Descargar Excel
                </button>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <Form.Group as={Col}>
              <InputGroup className="shadow">
                <InputGroup.Prepend>
                  <InputGroup.Text className="inputGroup ">
                    <FontAwesomeIcon color="#0073B5" icon={faSearch} />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Buscar por título o referencia..."
                  className="form-control"
                  onChange={({ target: { value } }) => searchBar(value)}
                />
              </InputGroup>
            </Form.Group>
          </div>
          <Table striped bordered hover>
            <thead>
              <tr>
                {Object.keys(columnHeaders).map((col) => (
                  <th
                    key={col}
                    onClick={() => sortByColumn(col)}
                    style={{ cursor: "pointer" }}
                  >
                    {columnHeaders[col]}{" "}
                    {sortConfig?.key === col
                      ? sortConfig.direction === "asc"
                        ? "▲"
                        : "▼"
                      : ""}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {displayProjects?.length > 0 ? (
                displayProjects.map(
                  ({
                    id,
                    tituloEs,
                    estado,
                    referenciaInterna,
                    fechaInicio,
                    fechaProrroga,
                    gestionadoPor,
                    staffProjects,
                  }) => {
                    // Filtramos los IPs
                    const ips =
                      staffProjects
                        ?.filter(({ projectRole }) => projectRole === "ip")
                        .map(
                          ({ staff }) => `${staff.nombre} ${staff.apellidos}`
                        )
                        .join(", ") || "-";

                    return (
                      <tr
                        key={id}
                        className="pointer"
                        onClick={() =>
                          history.push(`${ROUTES.Projects.all}/${id}`)
                        }
                      >
                        <td>{tituloEs}</td>
                        <td>{estado || "-"}</td>
                        <td>{referenciaInterna || "-"}</td>
                        <td>
                          {fechaInicio
                            ? new Date(fechaInicio).toLocaleDateString()
                            : "-"}
                        </td>
                        <td>
                          {fechaProrroga
                            ? new Date(fechaProrroga).toLocaleDateString()
                            : "-"}
                        </td>
                        <td>{ips}</td>
                        <td>{gestionadoPor || "-"}</td>
                      </tr>
                    );
                  }
                )
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                    No hay proyectos para mostrar
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </>
      )}
    </div>
  );
};
